module.exports = __webpack_public_path__ + "img/settingIcon.709e22aa.png";